<template lang="pug">
div
  buy-modal()
  section.full__video
    .intro__content.intro__content--mobile.influencerlp--header
      img#productLogo(srcset='https://cdn.flixel.com/static/static-web/products/mac/cinemagraphpro@2x.png 2x, https://cdn.flixel.com/static/static-web/products/mac/cinemagraphpro.png 1x')
      h2 Cinemagraphs made easy. Buzzoole creators save 50% on an annual plan after a free trial. Don’t miss this incredible chance to bring your stories to life!
      .btn__group.btn__group--splash
        buy-button(
          classes='btn btn--purpleLight btn__splash',
          product='weekTrial',
          coupon='FLXBZOL50',
          copy="Free Trial"
        )
    .fluid__video
      .intro__content.intro__content--desktop.influencerlp--header
        img#productLogo(srcset='https://cdn.flixel.com/static/static-web/products/mac/cinemagraphpro@2x.png 2x, https://cdn.flixel.com/static/static-web/products/mac/cinemagraphpro.png 1x')
        h2 Cinemagraphs made easy. Buzzoole creators save 50% on an annual plan after a free trial. Don’t miss this incredible chance to bring your stories to life!
        .btn__group.btn__group--splash
          buy-button(
            classes='btn btn--purpleLight btn__splash',
            product='weekTrial',
            coupon='FLXBZOL50',
            copy="Free Trial"
          )
      .video__overlay
      iframe(src='https://media.flixel.com/cinemagraph/48fxias44tki292u4tbx?hd=true' allow='autoplay')
      .credit
        a(target='_blank' href='https://flixel.com/stephen_knifton/') stephenknifton

  brands

  section.influencerlp
    .product__callout
      .callout--container
        h1 Create Thumb-Stopping Cinemagraphs for Social
        p Cinemagraphs are the new visual medium that capture attention in ways that still photos no longer can. They’re living photos. 

    .product__section
      .product__section--container
        .product__section--content
          .productItem__title
            img(srcset='https://cdn.flixel.com/static/static-web/products/mac/icons/cinemagraph-pro-icon@2x.png 2x, https://cdn.flixel.com/static/static-web/products/mac/icons/cinemagraph-pro-icon.png 1x')
            h2
              | Cinemagraph Pro 
              span for macOS
          .productItem__desc
            p Cinemagraphs are the new visual medium that capture attention in ways that still photos no longer can. They’re living photos. And now, creating stunning cinemagraphs is fast and easy with Cinemagraph Pro. Sign up for a FREE 7-day trial and save 50% on a Flixel Plan. Your membership gives you access to the world’s best cinemagraph creation tools and web services, exclusive to Buzzoole influencers.
            .btn__group
              buy-button(
                classes='btn btn--purpleLight btn__splash',
                product='weekTrial',
                coupon='FLXBZOL50',
                copy="Free Trial"
              )
          img#designaward(srcset='https://cdn.flixel.com/static/static-web/awards/awardada@2x.png 2x ,https://cdn.flixel.com/static/static-web/awards/awardada.png 1x')
        .product__section--cinemagraph.cpCinemagraph
          .fluid__video
            iframe(src='https://media.flixel.com/cinemagraph/0xvngzr9i1zqggsxptzv?hd=false')
  section.influencerlp
    .product__callout
      .callout--container
        h1 Bring Your Stories to Life with Cinemagraphs
        p Composed like a great photo, but with a subtle hint of repeating video motion, cinemagraphs tell a vivid story that engages audiences. Here’s why influencers around the world are using cinemagraphs as a part of their content strategy.

  section.product__section.product__section--carousel.product__section--carouselBlack
    .carousel__item.fluid__video.carousel__item--wide
      iframe(src='https://media.flixel.com/cinemagraph/q0ltqf71unjk8mk8dnao?hd=true' allow='autoplay')
    .carousel__item.fluid__video.carousel__item--thin
      iframe(src='https://media.flixel.com/cinemagraph/5u69pzstc7nr7dwwna4h?hd=true' allow='autoplay') 
    .carousel__item.fluid__video.carousel__item--wide
      iframe(src='https://media.flixel.com/cinemagraph/ken6qxdpc1td5lai1dgy?hd=true' allow='autoplay')
    .carousel--mobile
      iframe(src='https://media.flixel.com/cinemagraph/q0ltqf71unjk8mk8dnao?hd=true' allow='autoplay')

  section.carousel__attributions
    h2 Check out more by the artists featured here.
    .attributions
      a(href='https://flixel.com/jaiderrios/' target="_blank") jaiderrios
      a(href='https://flixel.com/ThumbStopStudio/' target="_blank") ThumbStop.Studio
      a(href='https://flixel.com/apricotberlin/' target="_blank") apricotberlin
    .attributions--mobile
      a(href='https://flixel.com/apricotberlin/' target="_blank") apricotberlin

  section.influencerlp__ios
    .product__section.product__section--ios
      .product__section--container.product__section--reverse
        .product__section--content
          .productItem__title
            h2 Cinemagraphs are Easy to Create
          .productItem__desc
            p Traditional video requires more time, skills, and equipment. You only need a tripod, a camera or iPhone, and Cinemagraph Pro to easily create video content that stands out and captures attention. Whether you’re a travel blogger, lifestyle influencer, or foodie, you’ll be able to create cinemagraphs that uniquely express your story, and excite your audience.
        .product__section--image
          img#iosImage(srcset='https://cdn.flixel.com/static/static-web/products/ios/cinemagraph-pro-ios@2x.png 2x, https://cdn.flixel.com/static/static-web/products/ios/cinemagraph-pro-ios.png 1x')

  section.influencerlp
    .landingPage__section--cinemagraphFull
      .influencerlp__container
        h1 Share Cinemagraphs On Blogs and Social Media and Stand Out
        p Share great content on the platforms that matter the most to you, while standing out. Cinemagraphs auto-play and auto-loop on Facebook, Instagram, Twitter, and Snapchat. You can also embed cinemagraphs on your blogs and websites in beautiful HD quality.
      .fluid__video
        iframe(src='https://media.flixel.com/cinemagraph/e8vj14sr3faxv1ff2h40?hd=true' allow='autoplay')
        .credit
          a(target='_blank' href='https://flixel.com/apricotberlin/') apricotberlin

  section.influencerlp
    .landingPage__section--container
      .landingPage__section--content
          h1 Cinemagraphs Perform Better Than Still Photos
          p Cinemagraphs cause audiences to pay attention to your content and engage with your storytelling more than still photos. They will be amazed by the hint of motion, and take action with a comment, like, share, or follow. Case studies show that cinemagraphs receive up to 51x higher engagement than still photos.
      .landingPage__section--image
        img(srcset='https://cdn.flixel.com/static/static-web/influencerlp/pepsistats@2x.png 2x, https://cdn.flixel.com/static/static-web/influencerlp/pepsistats.png 1x')

  section.influencerlp
    .product__callout
      .callout--container
        h1 Create Stories That Your Brand Partners Will Love
        p Your brand partners want to see how you can authentically combine their stories with yours on social media. Show how those stories fit together in a beautiful cinemagraph, and get results that your audience and partners will love.
        buy-button(
          classes='btn btn--purpleLight',
          product='weekTrial',
          coupon='FLXBZOL50',
          copy="Free Trial"
        )

  section.influencerlp
    .landingPage__section--container
      .landingPage__section--content
          h1 Join the Growing Community of Cinemagraph Creators
          p Visual storytellers and influencers around the world use cinemagraphs to share more mesmerizing stories on social media, blogs, and websites. Get inspired by 10 successful cinemagraph Instagrammers and start your cinemagraph journey today.
          a(href="http://blog.flixel.com/10-cinemagraph-instagrammers-you-should-be-following/") Read more
      .cinemagraph__section--image
        .fluid__video.influencer__cinemagraph
          iframe(src='https://media.flixel.com/cinemagraph/ryziua2d056kb7est72v/' allow='autoplay')
          .credit
            a(target='_blank' href='https://flixel.com/mattie/') mattie

  section.flixelPlan__section
    .flixelPlan__container
      h1 Get all the apps with the Flixel Plan
      p A Flixel Cloud Web+Apps plan gives you access to Cinemagraph Pro for macOS and iOS, Persecond for macOS, plus the world's leading service for hosting and sharing your HD quality cinemagraphs on the web, and social networks. It's your best value.
      .btn__group        
        buy-button(
          product='weekTrial',
          coupon='FLXBZOL50',
          classes='btn btn--purpleLight'
          copy="Free Trial"
        )
</template>

<script>
import brands from 'components/Brands.vue';
import buyButton from 'components/buyButton.vue';
import buyModal from 'components/buyModal.vue';

export default {
  name: 'Buzzoole',
  components: {
    'buy-button': buyButton,
    'buy-modal': buyModal,
    'brands': brands,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/landingPages/influencer/buzzoole/buzzoole.vue